import { Gender } from '@enums/gender';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { ConsultationRequestRequest } from '@models/consultation-request/consultation-request-request';
import { DateData } from '@models/date-data';

import { ConsultationRequestHelper } from './consultation-request-helper';

export class ConsultationRequestPartner extends ConsultationRequestRequest {
  public name: { first: string; last: string };
  public height: { feet: number; inches: number };
  public weight: Number;
  public dob: DateData;
  public gender: string;
  public pregnant?: QuestionnaireAnswers;
  public symptoms: string;

  public constructor(partnerFormValues: any) {
    super();

    this.allergies = partnerFormValues.allergies;
    this.dob = ConsultationRequestHelper.convertObjectNumbersToStrings(partnerFormValues.birthday) as DateData;
    this.gender = partnerFormValues.gender;
    if (this.gender === Gender.Female) {
      this.pregnant = partnerFormValues.pregnant;
    }
    this.prescriptions = partnerFormValues.prescriptions;
    this.symptoms = ConsultationRequestHelper.getSymptomsArrayFromValues(partnerFormValues.symptoms).join(', ');
    this.name = {
      first: partnerFormValues.firstName,
      last: partnerFormValues.lastName,
    };
    this.height = {
      feet: partnerFormValues.height_feet,
      inches: partnerFormValues.height_inches,
    };
    this.weight = partnerFormValues.weight;
  }
}
